// SEO Activity → category classification used by chart overlays + legend.
// Three user-facing categories; every activity_type below maps into exactly one.
// Both canonical (new) keys and legacy short keys are mapped so pre-existing
// records still colour correctly on the rank chart.

export const ACTIVITY_CATEGORIES = {
  backlinks: { label: "Backlinks", color: "#10b981" }, // green
  content:   { label: "Content",   color: "#0047FF" }, // brand blue
  technical: { label: "Technical", color: "#f59e0b" }, // orange
};

const TYPE_TO_CATEGORY = {
  // Backlinks
  backlink_built:        "backlinks",
  guest_post_published:  "backlinks",
  backlink_indexed:      "backlinks",
  // Content — canonical
  content_refresh:       "content",
  title_meta_updated:    "content",
  custom_note:           "content",
  competitor_note:       "content",
  // Content — legacy aliases
  title_meta:            "content",
  custom:                "content",
  // Technical — canonical
  onpage_update:         "technical",
  internal_links_added:  "technical",
  schema_added:          "technical",
  google_update_note:    "technical",
  // Technical — legacy aliases
  on_page:               "technical",
  internal_links:        "technical",
  schema:                "technical",
  google_update:         "technical",
};

export function categoryFor(activityType) {
  return TYPE_TO_CATEGORY[activityType] || "content";
}

export function colorFor(activityType) {
  return ACTIVITY_CATEGORIES[categoryFor(activityType)].color;
}

export function categoryLabelFor(activityType) {
  return ACTIVITY_CATEGORIES[categoryFor(activityType)].label;
}
